module.exports = __webpack_public_path__ + "static/media/noodle.dfd78819.png";